<style>
	.factoryItem{
    width:1050px;
    height:311px;
    background:rgba(255,255,255,1);
    box-shadow:0px 1px 6px rgba(153,152,155,0.16);
    opacity:1;
    border-radius:10px;
    position: relative;
    margin-bottom: 20px;
    padding:20px 25px 30px;
  }
  .factoryItemLeft{
    height:100%;
    width:223px;
    float:left;
    position: relative;
  }
  .factoryLogo{
    position: relative;
    height:145px;
    width:223px;
  }
  .factoryLogo img{
    height:100%;
    width:100%;
  }
  .starBox{
    height:25px;
    width:100%;
    position: relative;
    margin-top:16px;
  }
  .starBox img{
    height:25px;
    width:25px;
    float:left;
    margin-right:6px;
  }
  .factoryItemRight{
    width:730px;
    height:100%;
    margin-left:44px;
    float:left;
    position: relative;
  }
  .exhBtn{
    position: absolute;
    height:28px;
    width:auto;
    font-size:20px;
    font-family:PingFang SC;
    font-weight:500;
    line-height:28px;
    color:rgba(51,51,51,1);
    opacity:1;
    cursor: pointer;
    right:0;
    top:7px;
  }
  .factoryName{
    width:100%;
    height:40px;
    font-size:28px;
    font-family:PingFang SC;
    font-weight:500;
    line-height:40px;
    color:rgba(51,51,51,1);
    opacity:1;
    text-align: left;
    position: relative;
  }
  .factoryAddress{
    height:26px;
    width:100%;
    margin-top:15px;
    font-size:18px;
    font-family:PingFang SC;
    font-weight:500;
    line-height:26px;
    color:rgba(51,51,51,1);
    opacity:1;
    padding-left:36px;
    position: relative;
    text-align: left;
  }
  .factoryAddress img{
    position: absolute;
    height:26px;
    width:26px;
    left:0;
    top:0;
  }
  .factoryRemarks{
    height:25px;
    width:100%;
    margin-top:10px;
    font-size:18px;
    font-family:PingFang SC;
    color:rgba(102,102,102,1);
    line-height:25px;
    text-align: left;
   }
  .roomInfo{
    width:100%;
    height:100px;
    position: absolute;
    bottom: 0;
    left:0;
  }
  .roomInfo img{
    position: relative;
    float:left;
    height:100px;
    width:100px;
    margin-left:26px
  }
  .roomInfo img:nth-of-type(1){
    margin-left:0;
  }
  .mobile_starBox {
  	display: none;
  }
  @media screen and (max-width:500px) {
  	.factoryItem{
	    width:46%;
	    height:auto;
	    min-height: 230px;
	    background:rgba(255,255,255,1);
	    box-shadow:0px 1px 6px rgba(153,152,155,0.16);
	    border-radius:10px;
	    padding: 0;
	    padding-bottom: 14px;
	    position: relative;
	    margin: 0;
	    margin-bottom: 20px;
	    margin-right: 5px;
	    margin-left: 6px;
	    float: left;
	  }
	  .factoryItemLeft{
	    height:112px;
	    width:100%;
	    float:left;
	    position: relative;
	  }
	  .factoryLogo{
	  	border-radius:10px 10px 0 0;
	    position: relative;
	    height:112px;
	    width:100%;
	  }
	  .factoryLogo img{
	  	border-radius:10px 10px 0 0;
	  	position: absolute;
	  	left: 0;
	    height:100%;
	    width:100%;
	  }
	  .starBox{
	  	/*因为这个在左边容器中，需要重新放在右边*/
	  	display: none;
	  }
	  .mobile_starBox {
	  	/*新写的星星*/
	  	display: inline-block;
	  	float: left;
	  }
	  .mobile_starBox img {
	  	height:10px;
	    width:10px;
	    float:left;
	    margin-right:6px;
	  }
	  .factoryItemRight{
	    width:90%;
	    height:auto;
	    float:left;
	    margin-left: 7px;
	    position: relative;
	    overflow: hidden;
	  }
	  .exhBtn{
	  	display: none;
	  }
	  .factoryName{
	    width:100%;
	    height:30px;
	    font-size:14px;
	    font-weight:bold;
	    line-height:30px;
	    color:#333333;
	    opacity:1;
	    text-align: left;
	    position: relative;
	    overflow: hidden; text-overflow:ellipsis; white-space: nowrap;
	  }
	  .factoryAddress{
	    height:auto;
	    width:100%;
	    margin-top:17px;
	    font-size:12px;
	    line-height:14px;
	    color:#333333;
	    padding-left:14px;
	    position: relative;
	    text-align: left;
	  }
	  .factoryAddress img{
	    position: absolute;
	    height:12px;
	    width:12px;
	    left:0;
	    top:1px;
	  }
	  .factoryRemarks{
	    height:auto;
	    min-height: 14px;
	    width:100%;
	    margin-top:7px;
	    font-size:12px;
	    color:#666666;
	    line-height:14px;
	    text-align: left;
	   }
	  .roomInfo{
	  	display: none;
	  }
	  @media screen and (max-width:340px) {
	  	.factoryItem{
		    width:45%;
		    height:auto;
		    min-height: 240px;
		    background:rgba(255,255,255,1);
		    box-shadow:0px 1px 6px rgba(153,152,155,0.16);
		    border-radius:10px;
		    padding: 0;
		    padding-bottom: 14px;
		    position: relative;
		    margin: 0;
		    margin-bottom: 20px;
		    margin-right: 5px;
		    margin-left: 6px;
		    float: left;
		  }
	  }
  }
</style>

<template>
	<div class='factoryItem'>
    <div class='factoryItemLeft'>
      <div class='factoryLogo'>
        <img @click="gotoExh" :src="info.logo" alt="">
      </div>
      <div class='starBox'>
        <img src="../assets/star.png" alt="" v-for='item in [1,2,3,4,5]'>
      </div>
    </div>
    <div class='factoryItemRight'>

      <div class='factoryName'>{{info.name}}</div>
       <div class='mobile_starBox'>
        <img src="../assets/star.png" alt="" v-for='item in [1,2,3,4,5]'>
      </div>
      <div class='factoryAddress'>
        <img src="../assets/address.png" alt="">
        {{info.address||"无"}}
      </div>
      <div class='factoryRemarks'>
        说明 : {{info.guigui_remarks||"无"}}
      </div>
      <div class='roomInfo'>
        <img :src="item.img_url" alt="" v-for='item in info.someRooms.slice(0,6)'>
      </div>
      <div class='exhBtn' @click='gotoExh'>商城 ({{info.model_count||0}}) ></div>
    </div>
    <div style="clear: both;"></div>
  </div>
</template>

<script>
	export default {
		components:{

		},
		props:['info'],
		data() {
			return {

			}
		},
		computed: {

		},
		mounted() {

		},
		methods: {
      gotoExh(){
        let that=this
        window.open('http://s.eggi.cn/?x='+that.info.id)
      }
		}
	}
</script>
